import React from "react";
import { Facebook } from "../assets/facebook";
import { LinkedIn } from "../assets/linkedin";
import { X } from "../assets/x";
import { Youtube } from "../assets/youtube";
import { useTranslation } from "react-i18next";
import highlightWiseMate from "../hooks/highlightWord";

export const ThankYouCard = () => {
  const { t } = useTranslation();

  const CardSocialMedia = [
    {
      icon: <Facebook />,
      link: "https://www.facebook.com/assist.software.development",
    },
    {
      icon: <LinkedIn />,
      link: "https://www.linkedin.com/company/assist-software-srl",
    },
    { icon: <X />, link: "https://twitter.com/assistsoftware" },
    { icon: <Youtube />, link: "https://www.youtube.com/@Assist-softwareNet" },
  ];
  return (
    <div className="w-full flex justify-center my-[10vh] ">
      <div
        className="py-[24px] md:py-[40px] lg:py-[56px] w-fit border rounded-[30px] "
        style={{ background: "rgba(108, 59, 199, 0.10)" }}
      >
        <div className="flex flex-col gap-[30px] md:gap-[50px] lg:gap-[106px] items-center lg:w-[650px]">
          <div className="flex flex-col gap-[24px] items-center">
            <p className="text-primary-700 font-600 text-[24px] leading-[-1.68px] md:text-[44px] lg:text-[56px]">
              {String(t("thankYouCard.title"))}
            </p>
            <div className="w-full flex justify-center items-center">
              <p className="text-neutral-200 font-500 text-[16px] md:text-[24px] w-[95%] md:w-[85%] lg:w-[70%] text-center">
                {highlightWiseMate(
                  String(t("thankYouCard.subtitle")),
                  "font-500"
                )}
              </p>
            </div>
          </div>
          <div className="flex gap-[16px]">
            {CardSocialMedia.map((eachSocial, index) => (
              <a
                href={eachSocial.link}
                key={index}
                target="_blank"
                rel="noopener noreferrer"
              >
                {eachSocial.icon}
              </a>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
